import { useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { autoApplyFiltersAtom } from '@/atoms/filters/userFilters';

export const useAutoApplyFilters = () => {
  const [localAutoApply, setLocalAutoApply] = useState(false);
  const setAutoApplyFilters = useSetAtom(autoApplyFiltersAtom);

  // Read the comment below where we set localAutoApply if you're wondering what this useEffect is for.
  useEffect(() => {
    if (localAutoApply) {
      setAutoApplyFilters(true);
      setLocalAutoApply(false);
    }
  }, [localAutoApply]);

  // When triggering the auto apply, we set this in local state first and then use a useEffect to set the
  // global atom. This ensures that the new filter selections are available when the auto apply is processed.
  // Without this, the auto apply could happen while the old filter selections are still in place.
  return () => setLocalAutoApply(true);
};
